
  import { Vue, Component, Prop } from "vue-property-decorator";

  @Component
  export default class DefaultRadioButton extends Vue {
    @Prop({ type: String, required: true  }) readonly label!: string;
    @Prop({ type: String, required: true }) readonly value!: string;
    @Prop({ type: String, required: true }) readonly name!: string;
    @Prop({ type: Boolean, default: false }) readonly checked!: boolean;
    @Prop({ type: Boolean, default: false }) readonly small!: boolean;

    handleChange(event: any): void {
      this.$emit("input", event.target.value);
    }

    get styles(): string {
      if (this.small) {
        return "default_radio small";
      }
      return "default_radio";
    }
  }
